"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var LocaleProvider_1 = __importDefault(require("../LocaleProvider"));
var footer = function (props) {
    var className = props.className, text = props.text;
    var cn = classnames_1.default(className, "emankit__footer");
    var _a = react_1.useState(true), value = _a[0], set = _a[1];
    react_1.useEffect(function () {
        var forceUpdate = function () {
            return function () { return set(!value); };
        };
        LocaleProvider_1.default.on(forceUpdate);
        return function cleanup() {
            LocaleProvider_1.default.off(forceUpdate);
        };
    });
    return (react_1.default.createElement("div", { className: cn },
        react_1.default.createElement("div", { className: "row no-gutters" },
            react_1.default.createElement("div", { className: "emankit__footer__second_column col-12 col-sm-5" },
                react_1.default.createElement("div", { className: "emankit__footer__links" }, props.children)),
            react_1.default.createElement("div", { className: "emankit__footer__first_column  col-12 col-sm-7" }, text))));
};
exports.default = footer;
//# sourceMappingURL=index.js.map